import { RestProvider } from "dataSources/types/restProvider";
import { BaseResource } from "e100-data-providers";

import { GetHistoryUserLocationForm, UserLocationResponse } from "../types";

export class UsersLocationApi extends BaseResource {
  path: string = "";

  constructor(provider: RestProvider) {
    super(provider);
    this.path = "";
  }
  geUserCurrentLocations(): Promise<UserLocationResponse> {
    return this.getChildResource("userslocation/currentlocations").getItems();
  }

  getUSerHistoryLocations(
    form: GetHistoryUserLocationForm
  ): Promise<UserLocationResponse> {
    return this.send(
      this.getChildResource("userslocation/locationsHistory")
        .request.post()
        .setBody(form)
    );
  }
}
